export default function camelCaseToSentenceCase(input) {
    // Add a space before each capital letter that is not at the beginning of the string
    var result = input.replace(/([a-z])([A-Z])/g, '$1 $2');

    // Capitalize the first letter and convert the rest to lowercase
    result = result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();

    return result;
}